import { ConfigurationEnumsService_enumsServiceGetGetEnum } from '@festina/collcalc-general-types/collcalc/hooks/ConfigurationEnumsService_enumsServiceGetGetEnum'

export const useFetchEnumValues =
  ConfigurationEnumsService_enumsServiceGetGetEnum.useSuspenseQuery
